import { Component, Input, AfterViewInit } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-edit-modal',
  templateUrl: './image-edit-modal.component.html',
  styleUrls: ['./image-edit-modal.component.scss']
})
export class ImageEditModalComponent implements AfterViewInit {
  @Input() image: string;

  public canvasRotation = 0;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  public fileData: File = null;

  constructor(private modalCtrl: ModalController) {}

  ngAfterViewInit() {
  }
  async close() {
    await this.modalCtrl.dismiss();
  }

  async save() {
    await this.modalCtrl.dismiss({ image: this.croppedImage });
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  rotateLeft() {
    this.canvasRotation -= 1;
  }

  rotateRight() {
    this.canvasRotation += 1;
  }
}
